var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightShadowAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.339 5.678L14.393 5.678 14.393 0 12.55 2.568 9.077 0 6.268 2.568 3.339 0z",
    transform: "translate(-664.000000, -112.000000) translate(665.030600, 113.346000)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M5.666 11.644c-2.594 0-4.703-2.11-4.703-4.703 0-2.593 2.109-4.703 4.703-4.703 2.594 0 4.703 2.11 4.703 4.703 0 2.593-2.109 4.703-4.703 4.703m0-8.304c-1.985 0-3.601 1.616-3.601 3.6 0 1.986 1.616 3.6 3.601 3.6 1.985 0 3.601-1.614 3.601-3.6 0-1.984-1.616-3.6-3.601-3.6",
    transform: "translate(-664.000000, -112.000000) translate(665.030600, 113.346000) translate(3.339000, 0.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.5,
    d: "M5.666 11.644c-2.594 0-4.703-2.11-4.703-4.703 0-2.593 2.109-4.703 4.703-4.703 2.594 0 4.703 2.11 4.703 4.703 0 2.593-2.109 4.703-4.703 4.703m0-8.304c-1.985 0-3.601 1.616-3.601 3.6 0 1.986 1.616 3.6 3.601 3.6 1.985 0 3.601-1.614 3.601-3.6 0-1.984-1.616-3.6-3.601-3.6",
    transform: "translate(-664.000000, -112.000000) translate(665.030600, 113.346000) translate(3.339000, 0.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.5,
    d: "M0 5.678L11.054 5.678 11.054 0 9.211 2.568 5.738 0 2.929 2.568 0 0z",
    transform: "translate(-664.000000, -112.000000) translate(665.030600, 113.346000) translate(3.339000, 0.000000)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.007 19.651c-.04-3.638-2.249-6.763-5.393-8.144-.35.29-.737.538-1.152.737 3.127 1.027 5.399 3.952 5.442 7.407H1.105c.045-3.455 2.316-6.38 5.443-7.407-.415-.199-.802-.447-1.153-.737C2.252 12.888.043 16.013.002 19.651H0v1.1h18.01v-1.1h-.003z",
    transform: "translate(-664.000000, -112.000000) translate(665.030600, 113.346000)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.5,
    d: "M18.007 19.651c-.04-3.638-2.249-6.763-5.393-8.144-.35.29-.737.538-1.152.737 3.127 1.027 5.399 3.952 5.442 7.407H1.105c.045-3.455 2.316-6.38 5.443-7.407-.415-.199-.802-.447-1.153-.737C2.252 12.888.043 16.013.002 19.651H0v1.1h18.01v-1.1h-.003z",
    transform: "translate(-664.000000, -112.000000) translate(665.030600, 113.346000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#368FEF",
    d: "M22.711 19.65c-.04-3.568-2.168-6.644-5.217-8.063l-.242-.065c-.186-.006-.685-.226-1.333-.455 1.476-.795 2.492-2.336 2.492-4.126 0-2.593-2.109-4.703-4.703-4.703-2.593 0-4.703 2.11-4.703 4.703 0 1.689.902 3.16 2.243 3.99-.328.147-.678.337-1.15.576-3.143 1.382-5.352 4.506-5.393 8.144h-.002v1.1h18.01v-1.1h-.002z",
    transform: "translate(-664.000000, -112.000000) translate(665.030600, 113.346000)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeWidth: 0.5,
    d: "M22.711 19.65c-.04-3.568-2.168-6.644-5.217-8.063l-.242-.065c-.186-.006-.685-.226-1.333-.455 1.476-.795 2.492-2.336 2.492-4.126 0-2.593-2.109-4.703-4.703-4.703-2.593 0-4.703 2.11-4.703 4.703 0 1.689.902 3.16 2.243 3.99-.328.147-.678.337-1.15.576-3.143 1.382-5.352 4.506-5.393 8.144h-.002v1.1h18.01v-1.1h-.002z",
    transform: "translate(-664.000000, -112.000000) translate(665.030600, 113.346000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#368FEF",
    d: "M8.182 5.678L19.235 5.678 19.235 0 17.393 2.568 13.919 0 11.111 2.568 8.182 0z",
    transform: "translate(-664.000000, -112.000000) translate(665.030600, 113.346000)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeWidth: 0.5,
    d: "M8.182 5.678L19.235 5.678 19.235 0 17.393 2.568 13.919 0 11.111 2.568 8.182 0z",
    transform: "translate(-664.000000, -112.000000) translate(665.030600, 113.346000)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightShadowAdmin);
export default __webpack_public_path__ + "static/media/light_shadow_admin.a9db51e93b4e07100c71a7ed27ac096d.svg";
export { ForwardRef as ReactComponent };